










import {Vue, Component, Prop} from "vue-property-decorator";
import CommonButton from "./CommonButton.vue"

@Component({ components: { CommonButton }})
export default class LogoutBtn extends Vue {
    @Prop() text: string;

    async logout() {
        this.$clearAllBodyScrollLocks();
        await this.$store.dispatch('resetSession');
        await this.$router.push({name: 'Login', params: { backend: this.$route.params.backend, eventId: this.$route.params.eventId }});
    }
}
